import React from "react";

import convertDateToString from "../../../../libs/convertDateToString";

import { MessageContainer, UserMessage } from "./styledUserMessageComponent";
import { Link } from "react-router-dom";
import { ROUTE_SIM, ROUTE_SIM_REPORT_ACTIVITY } from "../../../../routes";

// HINT:
// message types = {
// type 1 : Notices
// type 2 : Transaction
// type 3 : Points
// type 4 : Reports
// }

function UserMessageComponent({ message, userRole, messagesIsLoaded }) {
  const NewMessageType = () => {
    const simID = message?.sim_report ? message.sim_report.sim : null;
    const studentID = message.created_by.id;
    if (message?.type === 4) {
      return (
        <UserMessage className="d-grid align-items-center w-100">
          <img
            src={message?.created_by?.image}
            alt="دانش‌آموز"
            width="36"
            height="36"
            className="avatar align-self-start rounded-circle"
          />
          <b className="username">{message?.created_by?.name}: </b>
          <p
            className="content text-break mb-0 me-2"
            dangerouslySetInnerHTML={{ __html: message.content }}
          />
          {userRole === "student" ? (
            <Link
              to={{
                pathname: `${ROUTE_SIM}${message?.sim_report.sim}`,
                search: "tab=lab-report",
              }}
              className="report-link text-nowrap"
            >
              رفتن به آزمایش
            </Link>
          ) : (
            // TODO: Link to student report page
            <Link
              to={{
                pathname: `${ROUTE_SIM_REPORT_ACTIVITY}sim_id=${simID}&student_id=${studentID}`,
                state: { report: message, loading: messagesIsLoaded },
              }}
              className="report-link text-nowrap"
            >
              رفتن به آزمایش
            </Link>
          )}

          <time className="date text-nowrap">
            {convertDateToString("fullNumber", message?.created_at)}
          </time>
        </UserMessage>
      );
    } else {
      return (
        <div
          dangerouslySetInnerHTML={{ __html: message.content }}
          className={
            message?.type === 3
              ? "d-flex align-items-center align-self-start"
              : undefined
          }
        ></div>
      );
    }
  };

  const OldMessageType = () => {
    return (
      <>
        <div className="row px-2">
          <b className="col-12">{message?.title}</b>
          <p className="col text-break">{message?.content}</p>
          {/* <Link
            to={{
              pathname: `${ROUTE_SIM}${message?.sim_report_id}`,
              search: "tab=lab-report",
            }}
            className="col-auto text-nowrap"
          >
            رفتن به آزمایش
          </Link> */}
        </div>
      </>
    );
  };

  let messageElement = null;
  if (message.type) {
    messageElement = <NewMessageType />;
  } else {
    messageElement = <OldMessageType />;
  }

  return (
    <MessageContainer className="flex-column flex-md-row p-3 py-2 p-xl-4">
      {messageElement}
      {message?.type !== 4 && (
        <time className="align-self-end align-self-md-center text-nowrap">
          {convertDateToString("fullNumber", message?.created_at)}
        </time>
      )}
    </MessageContainer>
  );
}

export default UserMessageComponent;
